module.exports = __webpack_public_path__ + "static/media/cashback_green.106a65c7.svg";